import React from 'react'
import propTypes from 'prop-types'
import classNames from 'classnames'


export default function Textarea(props) {
  const textareaRef = React.useRef(null)
  const textareaRefFn = React.useCallback(
    node => {
      if (! node) return

      textareaRef.current = node

      node.style.height = 'auto'
      node.style.height = node.scrollHeight + 'px'

      const eventListener = e => {
        e.currentTarget.style.height = 'auto'
        e.currentTarget.style.height = e.currentTarget.scrollHeight + 'px'
      }

      node.addEventListener('input', eventListener, false)

    },
    [],
  )

  React.useEffect(() => {
    return () => {
      textareaRef.current.removeEventListener('input', () => {}, false)
    }
  }, [])

  return (
    <>
      <textarea
        ref={textareaRefFn}
        {...props.inputProps}
        className={classNames([
          'resize-none overflow-hidden',
          'placeholder-gray-400 text-gray-700 bg-white',
          'focus:outline-none focus:ring ring-primary-200',
          'border-0 p-4 rounded text-sm shadow w-full h-auto',
          props.className,
        ])}
      >
        {props.children}
      </textarea>
    </>
  )
}


Textarea.propTypes = {
  className: propTypes.string,
  inputProps: propTypes.object,
}
